import { api } from '../configs/axiosConfigs';

export const deleteListSort = async(listSortId: string) => {
  // make sure the server responds to missing tittle with the correct error so it gets caught and responded to properly
  return await api.delete(`/list-sorts/${listSortId}`);
};
